import React, {Component} from 'react'
import {connect} from 'react-redux'
import {
    Tab,
    Tabs,
    Icon,
    Typography
} from "@material-ui/core"
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import ReduxGroup from '../../../../store/actionreducers/group'
import ReduxMission from "../../../../store/actionreducers/mission"
import ReduxMedical from "../../../../store/actionreducers/adminMedical/medical"
import ReduxCity from "../../../../store/actionreducers/city"
import ReduxInstitution from "../../../../store/actionreducers/institution"
import {FuseAnimate, FusePageCarded} from '@fuse'
import {Link, withRouter} from 'react-router-dom'
import {bindActionCreators} from 'redux'
import {UecareAvatar, UecareAlertDialog} from "../../../../components"
import BasicInfoTab from "./tabs/BasicInfoTab"
import ServiceInfoTab from "./tabs/ServiceInfoTab"
import ExperienceTab from "./tabs/ExperienceTab"
import AgendaTab from "./tabs/AgendaTab"

class MedicalInfo extends Component {

    state = {
        tabValue: 0,
    }

    handleChangeTab = (event, tabValue) => {
        this.setState({tabValue})
    }

    async componentDidMount() {
        try {
            const medicalId = this.props.match.params.id
            await this.props.getMedical(medicalId)
        } catch (e) {
            console.warn('you got an error = ', e)
        }
    }

    render() {
        const {medical} = this.props
        const {tabValue} = this.state

        if (!medical.user) return ''
        else return (
            <FusePageCarded
                innerScroll
                header={
                    <div className="flex flex-1 p-32 items-center justify-between">
                        <div className="flex flex-col items-start max-w-full">
                            <div className="flex items-center max-w-full">
                                <FuseAnimate animation="transition.expandIn" delay={300}>
                                    <UecareAvatar
                                        src={medical.user.avatar?
                                        medical.user.avatar.url
                                        :"https://res.cloudinary.com/uecare/image/upload/v1531703417/DefaultImage/medicalHead_3x.png"}
                                        className="w-80 h-80 mr-16"/>
                                </FuseAnimate>
                                <div className="flex flex-col min-w-0">
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <div>
                                            <Typography className="text-16 sm:text-20">
                                                {`${medical.user.name} ${medical.job && medical.job.name}`}
                                            </Typography>
                                            <Typography className="text-6 truncate">
                                                {`${medical.user.nickname ||　"無暱稱"} 
                                                ${medical.institution && medical.institution.name}`}
                                            </Typography>
                                        </div>
                                    </FuseAnimate>
                                </div>
                            </div>
                        </div>
                        <Typography className="normal-case flex text-24 items-center" component={Link}
                                    role="button" to="/apps/institutionMedical">
                            <Icon className="mr-4 text-24">arrow_back</Icon>
                            回到列表
                        </Typography>
                    </div>
                }
                contentToolbar={
                    <Tabs
                        value={tabValue}
                        onChange={this.handleChangeTab}
                        indicatorColor="secondary"
                        textColor="secondary"
                        scrollable
                        scrollButtons="auto"
                        classes={{root: "w-full h-64"}}
                        className='bg-grey-light'>
                        <Tab className="h-64 normal-case font-extrabold" label="基本資訊"/>
                        <Tab className="h-64 normal-case font-extrabold" label="服務設定"/>
                        <Tab className="h-64 normal-case font-extrabold" label="個人簡介設定"/>
                        {medical.job.name === "專科醫師" &&
                        <Tab className="h-64 normal-case font-extrabold" label="排班表"/>}
                    </Tabs>
                }
                content={
                    <div>
                        <div className="p-16 sm:p-24 w-full">
                            {tabValue === 0 && (<BasicInfoTab/>)}
                            {tabValue === 1 && (<ServiceInfoTab/>)}
                            {tabValue === 2 && (<ExperienceTab/>)}
                            {tabValue === 3 && (<AgendaTab medical={medical}/>)}
                        </div>
                        <UecareAlertDialog/>
                    </div>
                }
            />
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCities: ReduxCity.ActionCreator.getCities,
        getMission: ReduxMission.ActionCreator.getMission,
        setMission: ReduxMission.ActionCreator.setMission,
        getMissions: ReduxMission.ActionCreator.getMissions,
        getMedical: ReduxMedical.ActionCreator.getMedical,
        getMedicals: ReduxMedical.ActionCreator.getMedicals,
        getInstitutions: ReduxInstitution.ActionCreator.getInstitutions,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
    }, dispatch)
}

function mapStateToProps({adminMedicalList: {medical}}) {
    return {medical}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MedicalInfo))



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/MedicalInfo.js